import { lazyLoad } from 'utils/loadable';

export const WorkExperienceLoadable = lazyLoad(
  () => import('./components/WorkExperienceGrid'),
  module => module.WorkExperienceGrid,
);
